export { SplitToTabs } from './split-to-tabs'
